import { render, staticRenderFns } from "./LocationMappingAdd.vue?vue&type=template&id=a1ed5954&scoped=true"
import script from "./LocationMappingAdd.vue?vue&type=script&lang=js"
export * from "./LocationMappingAdd.vue?vue&type=script&lang=js"
import style0 from "./LocationMappingAdd.vue?vue&type=style&index=0&id=a1ed5954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ed5954",
  null
  
)

export default component.exports